import ProductAvatar from "./product-avatar";

export default ProductAvatar;